import { Stage as PixiStage } from '@inlet/react-pixi';
import { ContextBridge, BackgroundComponent, PersonComponent, PixiSpinner } from 'components';

import React, { FC, memo } from 'react';
import { ReactReduxContext, useSelector } from 'react-redux';
import { getGlobal, getBGLoaded, getPersonsLoaded } from 'store';
import { BubbleWrapper } from '../BubbleWrapper';

type Props = {
  play: boolean;
};

export const Scene: FC<Props> = memo(({ play }) => {
  const { height, width } = useSelector(getGlobal);
  const isBGLoaded = useSelector(getBGLoaded);
  const isPersonsLoaded = useSelector(getPersonsLoaded);

  return (
    <ContextBridge
      Context={ReactReduxContext}
      render={(ch) => (
        <PixiStage
          height={height}
          width={width}
          options={{ resolution: window?.devicePixelRatio || 1 }}
        >
          {ch}
        </PixiStage>
      )}
    >
      <>
        <BackgroundComponent />
        {!isPersonsLoaded ? <PixiSpinner /> : null}
        <PersonComponent />
        {isBGLoaded && isPersonsLoaded && play ? <BubbleWrapper /> : null}
      </>
    </ContextBridge>
  );
});
